/* eslint-disable camelcase */
import React, { Component } from "react";
import {
//   Title,
//   Heading,
//   Answer,
//   Quetion,
//   ButtonPrev,
//   ButtonNext,
//   ButtonSubmit, ButtonWrapper, 
//   ModalStyled
} from "./popupstyle";

import PropTypes from "prop-types";
// import { Modal } from 'react-bootstrap';
const Result = React.lazy(() => import('./result'));
import _ from "lodash";
import { SubmitQuiz, getUserQuizScore } from '../../redux/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { QuestionContainer, RenderQuestionContainer, RenderSurveyQuestions, StepIndicator, StepWrapper, SurveyTopBar,ButtonContainer, OptionContainer } from "../UserSurveyV1/styles";
import { fetchApi } from "../../utils/methods";
import { BackArrowFeed } from "../../utils/icons";
import { toast } from "react-toastify";
import { getQuizAPI } from "../../redux/constants/apiConstants";
import Waiting from "../Waiting";
import { t } from "i18next";
import CommonButton from "../common/CommonButton/CommonButton";

class NewArticleQuiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quizQuestions: [],
      optionSelection: [],
      duplicateDefaultSelection: [],
      buttonDisable: true,
      data: '',
      id: 0,
      showResult: false,
      showQuiz: false,
      isLoading:false
    };
  }

  componentDidMount() {
    // const { quizQuestions } = this.props;
    // if (quizQuestions) {
    //   let arr = [];
    //   for (let i = 0; i < quizQuestions.length; i++) {
    //     let obj = {};
    //     obj['quiz_id'] = quizQuestions[i].id;
    //     obj['choices'] = [];
    //     arr.push(obj);
    //   }
    //   this.setState({ quizQuestions, optionSelection: arr, duplicateDefaultSelection: JSON.parse(JSON.stringify(arr)) });
    // }

    const articleId = this.props.match.params.id

    this.fetchQuizzData(articleId)
  }

  fetchQuizzData = async(articleId) => { 
    this.setState({isLoading:true}); 
    try { 
      const res = await fetchApi(getQuizAPI + "/" + articleId,"GET"); 

      if(res?.data?.message){ 
        toast.error(res.data.message) 
      }else{ 

        const quizQuestions = res?.data?.[0] ||res?.data?.quiz

        if (quizQuestions) {
          let arr = [];
          for (let i = 0; i < quizQuestions.length; i++) {
            let obj = {};
            obj['quiz_id'] = quizQuestions[i].id;
            obj['choices'] = [];
            arr.push(obj);
          }
          this.setState({ quizQuestions, optionSelection: arr, duplicateDefaultSelection: JSON.parse(JSON.stringify(arr)),isLoading:false });
        }

      } 
    } catch (error) { 
      toast.error(error); 
      this.setState({isLoading:false}) 
    } 
  };

  markAnswer = (optionId, questionIndex, list) => {
    const dupQuestion = this.state.optionSelection;
    if (list && list.no_of_correct_choices === 1) {
      let choiceSelection = [];
      choiceSelection.push(optionId);
      dupQuestion[questionIndex]['choices'] = choiceSelection;
      this.setState({ optionSelection: dupQuestion }, () => this.disablebutton());
    }
    else {
      let arr = dupQuestion[questionIndex].choices;
      let index = arr.indexOf(optionId);
      if (index === -1) {
        arr.push(optionId);
      }
      else {
        arr.splice(index, 1);
      }
      dupQuestion[questionIndex]['choices'] = arr;
      this.setState({ optionSelection: dupQuestion }, () => this.disablebutton());
    }
  };

  multipleChoices = (id, questionIndex) => {
    let arr = this.state.optionSelection[questionIndex].choices;
    let index = arr.indexOf(id);
    if (index !== -1)
      return true;
    else
      return false;
  };

  disablebutton = () => {
    const { optionSelection, id } = this.state;
    let bool = false;
    if (_.isEmpty(optionSelection[id].choices)) {
      bool = true;
    }
    this.setState({ buttonDisable: bool })
  };

  prevHandle = () => {
    const { id } = this.state;
    id > 0 &&
      this.setState({
        id: id - 1,
      }, () => {
        this.disablebutton();
      });
  };

  nextHandle = () => {
    const { id } = this.state;
    id - 1 < this.state.quizQuestions.length &&
      this.setState({
        id: id + 1,
      }, () => {
        this.disablebutton();
      });
  };

  handleSubmit = () => {
    let storeDataQuestions = JSON.parse(JSON.stringify(this.state.duplicateDefaultSelection));
    this.setState({
      showResult: true,
      optionSelection: storeDataQuestions,
      buttonDisable: true,
      data: '',
      id: 0,
      showQuiz: false,
    });
  };

  restartQuiz = () => {
    let storeDataQuestions=JSON.parse(JSON.stringify(this.state.duplicateDefaultSelection));
    this.setState({
      showResult: false,
      optionSelection: storeDataQuestions,
      buttonDisable: true,
      data: '',
      id: 0,
      showQuiz: false,
    });
  };

  submitQuiz = () => {
    let obj = {};
    const { /*adventureArticle,*/ history, submitQuiz,match } = this.props;
    const { optionSelection} = this.state;
    // const stringArray = history.location.pathname.split('/');
    obj['journey_id'] =match.params.id;
    obj['quiz'] = optionSelection;
    this.setState({
      buttonDisable: true
    });
    const category = history?.location?.state?.category;
    submitQuiz(obj, category, this.handleSubmit,history);
  };

  createStepIndicator = (currentStep, totalSteps) => { 
    const stepIndicator = []; 
    let step; 
    for (step = 0; step < totalSteps; step++) { 
      const isCompleted = step < currentStep; 
      const isActive = step === currentStep; 
      const stepper = ( 
        <StepIndicator 
          id={`step-indicator-${step + 1}`} 
          isActive={isActive} 
          isCompleted={isCompleted} 
        ></StepIndicator> 
      ); 
      stepIndicator.push(stepper); 
    } 
    return ( 
      <StepWrapper style={{ display: "flex", justifyContent: "center" }}> 
        {stepIndicator} 
      </StepWrapper> 
    ); 
  }; 

  renderQuestionContainer = (questionList) => { 
    const { buttonDisable, id } = this.state; 
    const question = questionList[id]; 
    return ( 
      <RenderSurveyQuestions> 
        <RenderQuestionContainer> 
          <QuestionContainer id={`question-container-${id + 1}`}> 
            <div> {`Question ${id + 1}`} 
            </div> 
            <div style={{ marginBottom: "10px",wordBreak:"break-all",padding:"0px 30px" }}> 
              {question?.quiz} 
            </div> 
          </QuestionContainer> 
          <div id={`question-separator-${id + 1}`} 
            style={{ 
              width: "100%", 
              border: "1px solid #DCDCDC", 
              marginBottom: "35px", 
            }} 
          ></div> 
          {this.renderOptions(question?.choices, question?.id)}
        </RenderQuestionContainer> 

        <ButtonContainer justify={id === 0}> 
          {id > 0 && ( 
            <CommonButton
              // newBranding={true} 
              btnType={"squareIcon"} 
              styles={{color:"white",textColor:"#184A61",border:"#DA6C74",width:"200px", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center",background:'transparent'}} 
              onClick={this.prevHandle}
              title={t("Back")} 
              // icon={Arrows()} 
            /> 
          )} 

          <CommonButton
            newBranding={true} 
            btnType={"squareIcon"} 
            styles={{color:"#DA6C74", marginAuto:'auto'}} 
            title={id + 1 === questionList.length? "Submit": "Next"} 
            // nextIcon={id + 1 === questionList.length ? "" : NextArrows("white")} 
            onClick={() => !buttonDisable && id + 1 === questionList.length ? this.submitQuiz() : !buttonDisable &&  this.nextHandle() } disabled={buttonDisable}
          /> 
        </ButtonContainer> 
      </RenderSurveyQuestions> 
    ); 
  }; 

  renderOptions = (options, questionIndex) => { 
    const { optionSelection,id,quizQuestions } = this.state; 
    return options?.map((item, index) => ( 
      <OptionContainer 
        key={`${index}-${item.id}`} 
        onClick={() => this.markAnswer(item.id, id, quizQuestions?.[id])}
        isActive={optionSelection?.[id]?.['choices']?.includes(item.id)} 
        // bgColor={this.getSelectedOptionBackground(item.points)} 
        bgColor={'#DA6C74'}
        id={`option-${questionIndex}-${item.id}`} // Added ID 
      > 
        {/* <div> 
          <CheckMarkContainer> 
            <CheckMark 
            bgColor={'#DA6C74'}
            // bgColor={this.getSelectedOptionBackground(item.points)}
            /> 
          </CheckMarkContainer> 
        </div>  */}
        <div className="option" style={{wordBreak:'break-word',width:'100%'}}>{item.choice}</div> 
      </OptionContainer> 
    )); 
  }; 

  render() {
    const { /*showModal,*/ closeModal, /*adventureArticle,*/ userQuizScore, t } = this.props;
    const { showResult, quizQuestions, /*buttonDisable,*/ id, /*optionSelection*/isLoading } = this.state;
    if(isLoading) {
      return <Waiting />
    }

    return (
      <>
        {/* <ModalStyled show={showModal} onHide={() => { this.restartQuiz(); closeModal() }} > */}
        {!showResult ? <div style={{marginTop:'-110px'}}>
          <SurveyTopBar>
            <div className="row-one">
              <div className="icon" onClick={() => this.props.history.goBack()}>
                {BackArrowFeed()}
              </div>
              <div className="title">{t('Quiz')}</div>
            </div>
          
            <div>
              <div 
                style={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center", 
                  gap: "10px", 
                  marginTop: "10px", 
                }} 
                className="step-count"
              > 
                {`${id+1}/${quizQuestions.length}`} 
                {this.createStepIndicator( 
                  id, 
                  quizQuestions.length 
                )} 
              </div> 
            </div>
          </SurveyTopBar>
          {/* <Heading>
            <p> {adventureArticle.category_name}</p>
            <div >
              <img src="/public/images/NewDashboardV2/new_close_icon.png" width="20px" height="20px" onClick={() => closeModal()} />
            </div>
          </Heading>
   
          <Title>
            <h4>{adventureArticle.title}</h4>
   
            <p> {t("QUIZ QUESTIONS")}</p>
          </Title> */}

          {this.renderQuestionContainer(quizQuestions)}
   
          {/* <Quetion>
            <h5>
              {id + 1}/{quizQuestions && quizQuestions.length}
            </h5>
            <p>{quizQuestions && quizQuestions.length>0 && quizQuestions[id].quiz} ?</p>
   
            <h4>?</h4>
          </Quetion> */}
   
          {/* {quizQuestions && quizQuestions.length>0 && quizQuestions[id].choices.map((options, index) => (
            <Answer key={index} id="answer" onClick={() => this.markAnswer(options.id, id, quizQuestions && quizQuestions[id])} checked={options.id === optionSelection[id]['choices'][0]}>
              <p >{options.choice}</p>
            </Answer>
          ))} */}
          {/* <ButtonWrapper display={id}>
            {id ? (
              <ButtonPrev onClick={this.prevHandle}>
                <p> &lt;&lt; {t("Prev")} </p>
              </ButtonPrev>
            ) : null}
   
            {id === (quizQuestions && quizQuestions.length - 1) ? (
              <ButtonSubmit onClick={() => !buttonDisable && this.submitQuiz()} disabled={buttonDisable}>{t("Submit")}</ButtonSubmit>
            ) : (
              <ButtonNext onClick={() => !buttonDisable && this.nextHandle()} disabled={buttonDisable}>
                <p> {t("Next")} &gt;&gt;</p>
              </ButtonNext>
            )}
          </ButtonWrapper> */}

        </div> :  <React.Suspense fallback={<div>Loading...</div>}><Result closeModal={closeModal} restartQuiz={this.restartQuiz} userQuizScore={userQuizScore} /></React.Suspense>}
          
        {/* </ModalStyled> */}
      </>
    );
  }
}

NewArticleQuiz.propTypes = {
  adventureArticle: PropTypes.object,
  history: PropTypes.object,
  role: PropTypes.string.isRequired,
  quizQuestions: PropTypes.array,
  fetchQuizzes: PropTypes.func.isRequired,
  submitQuiz: PropTypes.func.isRequired,
  quizScore: PropTypes.object,
  fetchAdventureArticle: PropTypes.func.isRequired,
  match: PropTypes.object,
  loading: PropTypes.bool,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  restartQuiz: PropTypes.func.isRequired,
  adventureId: PropTypes.number,
  categoryName: PropTypes.string,
  getUserQuizScore: PropTypes.func.isRequired,
  userQuizScore: PropTypes.object,
  t: PropTypes.func
};

const mapStateToProps = (state) => ({
  userQuizScore: state.education.userQuizScore,
});

const mapDispatchToProps = (dispatch) => ({
  getUserQuizScore: (id) => dispatch(getUserQuizScore(id)),
  submitQuiz: (data, categoryName, push,history) => dispatch(SubmitQuiz(data, categoryName, push, history)),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewArticleQuiz)));